/* ============================================================
   Aurha Vitrine — interações
   1) "Ver mais": revela +N cards por clique; ao esgotar os renderizados,
      mostra o link "Ver todos os X produtos".
   2) Navegação por âncoras: scroll suave com offset do header sticky
      e realce da pílula da seção visível.
   Escopado por instância (data-attrs). Reinicializa em shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  // A section inclui este script; com várias seções na página, a tag <script>
  // pode executar mais de uma vez. Guard global: nas execuções seguintes só
  // reinicializa (idempotente) e sai, sem re-anexar listeners.
  if (window.__aurhaVitrine) {
    window.__aurhaVitrine.init();
    return;
  }

  function initGrid(root) {
    if (root.dataset.aurhaInit === '1') return;
    root.dataset.aurhaInit = '1';

    var step = parseInt(root.dataset.step, 10) || 8;
    var btn = root.querySelector('.aurha-vitrine__more-btn');
    var viewAll = root.querySelector('.aurha-vitrine__viewall');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.grid__item.aurha-hidden');
      for (var i = 0; i < step && i < hidden.length; i++) {
        hidden[i].classList.remove('aurha-hidden');
      }
      var remaining = root.querySelectorAll('.grid__item.aurha-hidden').length;
      if (remaining === 0) {
        // Nada mais renderizado: some o botão e (se houver mais na coleção) mostra "Ver todos".
        btn.hidden = true;
        if (viewAll) viewAll.hidden = false;
      }
    });
  }

  function getHeaderEl() {
    return document.querySelector('.header-wrapper') || document.querySelector('.section-header');
  }
  // Segue a borda inferior do header (que some/aparece no on-scroll-up): a promoção
  // e a barra grudam logo abaixo dele quando visível, e no topo quando ele some.
  function updateTopOffset() {
    var header = getHeaderEl();
    var b = header ? header.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty('--aurha-top-offset', Math.max(0, Math.round(b)) + 'px');
  }
  function setNavOffsets() {
    var banner = document.querySelector('.aurha-vitrine-banner-section');
    var nav = document.querySelector('.aurha-vitrine-nav-section');
    var bannerH = banner ? Math.round(banner.getBoundingClientRect().height) : 0;
    var navH = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
    var root = document.documentElement;
    root.style.setProperty('--aurha-banner-height', bannerH + 'px');
    // Offset da âncora = promoção + barra travadas (o header some ao rolar pra baixo).
    root.style.setProperty('--aurha-anchor-offset', (bannerH + navH + 12) + 'px');
    updateTopOffset();
  }

  function initNav() {
    var nav = document.querySelector('.aurha-vitrine-nav');
    if (!nav) return;
    setNavOffsets();

    var pills = Array.prototype.slice.call(nav.querySelectorAll('.aurha-vitrine-nav__pill'));
    var targets = pills
      .map(function (p) {
        var id = (p.getAttribute('href') || '').replace('#', '');
        var el = id ? document.getElementById(id) : null;
        return el ? { pill: p, el: el } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var scroller = nav.querySelector('.aurha-vitrine-nav__scroll');

    // Traz a pílula ativa para o centro da barra (só quando a barra rola na horizontal — mobile).
    function centerPill(pill) {
      if (!scroller) return;
      if (scroller.scrollWidth <= scroller.clientWidth + 4) return; // não é rolável (desktop)
      var target = pill.offsetLeft - (scroller.clientWidth - pill.offsetWidth) / 2;
      target = Math.max(0, Math.min(target, scroller.scrollWidth - scroller.clientWidth));
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    var currentActive = null;
    function setActive(pill) {
      if (pill === currentActive) return;
      currentActive = pill;
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      centerPill(pill);
    }

    // Clique manual também centraliza a pílula.
    pills.forEach(function (p) {
      p.addEventListener('click', function () { setActive(p); });
    });

    // Realce da seção visível (scroll-spy).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var match = targets.filter(function (t) { return t.el === entry.target; })[0];
            if (!match) return;
            setActive(match.pill);
          });
        },
        { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );
      targets.forEach(function (t) { io.observe(t.el); });
    }
  }

  // Desenha estrelas douradas próprias a partir do rating do Loox (data-rating/data-raters),
  // substituindo o widget preto do app. Remove a classe loox-rating para o Loox não sobrescrever.
  function initStars(scope) {
    (scope || document).querySelectorAll('.aurha-vitrine .loox-rating[data-rating]').forEach(function (el) {
      if (el.dataset.aurhaStars) return;
      el.dataset.aurhaStars = '1';
      var rating = parseFloat(el.getAttribute('data-rating'));
      var raters = (el.getAttribute('data-raters') || '').trim();
      if (!rating || rating <= 0) { el.style.display = 'none'; return; }
      var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
      var numTxt = rating.toFixed(1).replace('.', ',');   // 4,9
      var countTxt = '';
      var n = parseInt(raters, 10);
      if (!isNaN(n) && n > 0) {
        countTxt = n >= 1000
          ? (n / 1000).toFixed(1).replace(/\.0$/, '').replace('.', ',') + 'K'   // 3,1K / 11K
          : String(n);
      }
      el.classList.remove('loox-rating');
      el.classList.add('aurha-stars');
      var html =
        '<span class="aurha-stars__base" aria-hidden="true">★★★★★' +
        '<span class="aurha-stars__fill" style="width:' + pct + '%">★★★★★</span></span>' +
        '<span class="aurha-stars__num">' + numTxt + '</span>';
      if (countTxt) html += '<span class="aurha-stars__count">(' + countTxt + ')</span>';
      el.innerHTML = html;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.aurha-vitrine-grid[data-step]').forEach(initGrid);
    initStars(scope);
    initNav();
    // Segunda passada tardia para o caso de o Loox popular os divs após a primeira.
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { initStars(scope); }); });
    }
  }

  window.__aurhaVitrine = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    // Recalcula offsets do sticky em mudança de viewport.
    if (document.querySelector('.aurha-vitrine-nav')) setNavOffsets();
  });

  // Acompanha o header (on-scroll-up) para manter promoção + barra grudadas logo abaixo dele.
  var topTicking = false;
  window.addEventListener('scroll', function () {
    if (topTicking || !document.querySelector('.aurha-vitrine-nav-section')) return;
    topTicking = true;
    (window.requestAnimationFrame || function (cb) { cb(); })(function () {
      updateTopOffset();
      topTicking = false;
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
